import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------

const Nuevovehiculo = () => {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const handleClick = () => {
    navigate('/dashboard', { replace: true });
  };

  const manejadorLogin = async () => {
    navigate('/dashboard/carros', { replace: true });
  };

  return (
    <>
      <Stack spacing={3}>
        <Typography variant="h4" gutterBottom>
          Agregar Nuevo tipo vehiculo
        </Typography>
        <TextField name="email" label="Nombre" />
        <TextField name="email" label="Costo por KM" />
      </Stack>
      <br />
      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={manejadorLogin}>
        Agregar
      </LoadingButton>
    </>
  );
};

export default Nuevovehiculo;
